//
// Copyright (c) 2025 Comcast
//

import { useParams } from 'react-router'
import { useSelector } from 'react-redux'
import * as ticketingSystemsSelector from 'selectors/ticketingSystems'

// get current ticketing system by its id from URL and loaded list of ticketing systems
export const useCurrentTicketingSystem = () => {
  const params = useParams()
  const ticketingSystems = useSelector(ticketingSystemsSelector.ticketingSystems)
  const selectedTicketingSystemDisplayId = params.ticketingSystemDisplayId || null

  if (!selectedTicketingSystemDisplayId) {
    return null
  }

  const selectedTicketingSystem = ticketingSystems.find(ts => {
    return ts.displayId === selectedTicketingSystemDisplayId
  })

  return selectedTicketingSystem
}
